/* Presentation context accompanies a menu search without changing its query. */
(() => {
  const categories = { bracelets: 'Bracelets', necklaces: 'Necklaces' };
  const copy = {
    Bracelets: 'Find your everyday fit. Explore medical alert bracelets and personalize your favorite with custom engraving.',
    Necklaces: 'Keep important details close. Choose a medical alert necklace that suits your style and add your personal engraving.'
  };
  function update() {
    const url = new URL(location.href);
    const context = url.searchParams.get('med_browse');
    const intro = document.querySelector('[data-med-browse-intro]');
    if (!intro || !categories[context]) return;
    const query = (url.searchParams.get('q') || '').toLowerCase();
    // An explicit category link wins over the menu it came from.
    const category = /necklace|pendant/.test(query) ? 'Necklaces' : /bracelet/.test(query) ? 'Bracelets' : /\btag\b/.test(query) ? 'ID Tags' : categories[context];
    const audience = intro.dataset.medAudience;
    const prefix = { women: 'Women’s ', men: 'Men’s ', kids: 'Kids’ ' }[audience] || '';
    const title = `${prefix}Medical Alert ${category}`;
    const heading = intro.querySelector('h1');
    if (heading && heading.textContent !== title) heading.textContent = title;
    const current = intro.querySelector('[aria-current="page"]');
    if (current && current.textContent !== category) current.textContent = category;
    const description = intro.querySelector('.med-collection-description p');
    if (!audience && description && copy[category] && description.textContent !== copy[category]) description.textContent = copy[category];
    // Keep the display context through pagination and filter-removal links.
    document.querySelectorAll('results-list a[href]').forEach(link => {
      const target = new URL(link.getAttribute('href'), location.origin);
      if (target.origin !== url.origin || target.pathname !== url.pathname || target.searchParams.get('q') !== url.searchParams.get('q')) return;
      if (target.searchParams.get('med_browse') === context) return;
      target.searchParams.set('med_browse', context);
      link.setAttribute('href', target.pathname + target.search + target.hash);
    });
  }
  const start = () => {
    if (!document.querySelector('[data-med-browse-intro]')) return;
    update();
    const main = document.querySelector('main');
    if (main) new MutationObserver(update).observe(main, { childList: true, subtree: true });
    window.addEventListener('popstate', update);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
